import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import { useAuth } from '../../context/AuthContext';

export default function MenuPicker() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user?.role === 'admin';

  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState('');

  useEffect(() => {
    api.get('/brands').then(res => {
      const sorted = [...res.data].sort((a, b) => {
        if (isAdmin) {
          const oa = (a.owner_username || '').toLowerCase();
          const ob = (b.owner_username || '').toLowerCase();
          if (oa !== ob) return oa.localeCompare(ob);
        }
        return (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase());
      });
      setBrands(sorted);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSelect = (e) => {
    const id = e.target.value;
    setSelectedId(id);
    if (id) navigate(`/brands/${id}/price-list`);
  };

  const selected = brands.find(b => b.id === parseInt(selectedId));

  return (
    <div className="page" style={{ maxWidth: 560 }}>
      <div className="page-header" style={{ marginBottom: 28 }}>
        <h1 className="page-title">Price Edit</h1>
      </div>

      <div style={{ marginBottom: 8 }}>
        <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: '#757575', textTransform: 'uppercase', letterSpacing: 0.6, marginBottom: 6 }}>
          Brand
        </label>

        <div style={{ position: 'relative' }}>
          {/* Logo preview inside dropdown */}
          {selected?.logo_path && (
            <img
              src={selected.logo_path} alt=""
              style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', width: 28, height: 28, borderRadius: 6, objectFit: 'contain', background: '#f5f5f5', zIndex: 1, pointerEvents: 'none' }}
            />
          )}
          <select
            className="cat-select"
            value={selectedId}
            onChange={handleSelect}
            style={{ width: '100%', fontSize: 15, height: 52, paddingLeft: selected?.logo_path ? 50 : 16, borderRadius: 12 }}
          >
            <option value="">— Select a brand —</option>
            {brands.map(b => (
              <option key={b.id} value={b.id}>
                {b.name}{b.name_ar ? ' · ' + b.name_ar : ''}{isAdmin && b.owner_username ? ` (${b.owner_username})` : ''}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Empty state */}
      {!selectedId && !loading && (
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#bbb' }}>
          <div style={{ fontSize: 56, marginBottom: 14 }}>📋</div>
          <div style={{ fontSize: 15, fontWeight: 500, color: '#999' }}>Select a brand to open its menu editor</div>
          {brands.length === 0 && (
            <div style={{ marginTop: 16, fontSize: 13, color: '#bbb' }}>No brands available</div>
          )}
        </div>
      )}
    </div>
  );
}
